import React, {useContext, useEffect, useState} from 'react';

import Layout from './components/layout/Layout';

import {LicenseInfo} from '@mui/x-license-pro';

import './App.css';
import RouterRoutes from "./routerRoutes";
import ReactGA from 'react-ga4';
import PageContextZiggy from "./store/page-context-ziggy";
import axios from "axios";
import {AuthContext} from "@lb/mlib-components";
import LocationsContext from "./libs/locations";
import Loader from "./components/ui/Loader";

LicenseInfo.setLicenseKey(
    '88516f036af68aed3fba46f1c8c5bd84Tz0xMDQwNzksRT0xNzY1NDgxMjM2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
);

ReactGA.initialize("G-F91XVR3F67");

export const dataGridProStateVersion = 1

function App() {

    const pageCtxZiggy = useContext(PageContextZiggy)
    const locationContext = useContext(LocationsContext)

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        removeItemsFromLocalStorageOnce();
    }, [window['runConfig'].version]);

    function removeItemsFromLocalStorageOnce() {
        // Get the previous version from local storage
        const previousVersion = localStorage.getItem('previousVersion');

        // Check if the version has changed
        if (previousVersion !== window['runConfig'].version) {
            // Get all keys from local storage
            const keys = Object.keys(localStorage);

            // Iterate through each key
            keys.forEach(key => {
                // Check if the key includes "ColumnsState"
                if (key.includes("ColumnsState")) {
                    // Remove the item from local storage
                    localStorage.removeItem(key);
                }
            });

            // Store the current version in local storage
            localStorage.setItem('previousVersion', window['runConfig'].version);
        }
    }

    const [load, setLoad] = useState(false);

    const callLoad = () => {
        setLoad(!load);
    };

    useEffect(() => {
        axios.defaults.headers.common['X-Warehouse'] = `${pageCtxZiggy.warehouse ? pageCtxZiggy.warehouse === 'All' ? '' : pageCtxZiggy.warehouse : ''}`;
        callLoad()
    }, [pageCtxZiggy.warehouse])

    const authCtx = useContext(AuthContext);

    useEffect(() => {
        if (authCtx.isLoggedIn()) {
            setLoading(true)
            axios.get('/config/warehouse')
                .then((response) => locationContext.updateLocations(response.data))
                .finally(() => setLoading(false))
        }
    }, []);

    return (

        <React.Fragment>
            <Layout callLoad={callLoad}>
                <Loader active={loading}/>
                <RouterRoutes load={load}/>
            </Layout>
        </React.Fragment>
    )
}

export default App
